
  import { Prop, Component, Vue } from 'vue-property-decorator';
  import { OrderItemModModel } from '@/models';

  @Component({name: 'ProductListMods' })
  export default class ProductListMods extends Vue {
    @Prop() readonly mods!: OrderItemModModel[];
  }
